<template>
  <v-dialog :value="value" @input="$event => $emit($event)" persistent max-width="1000px">
    <v-card class="mx-auto">
      <!-- Cabeçalho -->
      <v-card-title class="primary white--text">
        <span class="headerClass">Criar nova Pessoa</span>
      </v-card-title>
      <v-divider></v-divider>

      <!-- Corpo -->
      <v-card-text class="mt-5">
        <v-form ref="validForm">
          <small>* Campos obrigatórios</small>
          <!-- DADOS PESSOAIS -->
          <v-row no-gutters>
            <v-col cols="12">
              <h4 class="subtitle-1 font-weight-medium mb-2">Dados Pessoais</h4>
            </v-col>

            <v-col cols="6">
              <v-text-field v-model="form.nome_completo" label="Nome Completo*" dense outlined :rules="[v => !!v || 'Obrigatório']"/>
            </v-col>

            <v-col cols="6" class="pl-2">
              <v-text-field v-model="form.nome_abreviado" label="Nome Abreviado" dense outlined />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="form.email"
                label="E-mail*"
                type="email"
                dense
                outlined
                :rules="[emailOrMatriculaRule, v => !v || /.+@.+\..+/.test(v) || 'Email inválido']"
              />
            </v-col>

            <v-col cols="6" class="pl-2">
              <v-text-field v-model="form.id_externo" label="Matricula*" dense outlined :rules="[emailOrMatriculaRule]"/>
            </v-col>

            <v-col cols="3">
              <v-autocomplete
                v-model="form.tipo_pessoa"
                label="Tipo Pessoa*"
                dense
                outlined
                :items="[
                  { text: 'Pessoa Física', value: 1 },
                  { text: 'Pessoa Jurídica', value: 2 },
                ]"
                item-text="text"
                item-value="value"
                :rules="[v => !!v || 'Obrigatório']"
                @change="updateMask"
              />
            </v-col>

            <v-col cols="5" class="pl-2">
              <v-text-field
                v-model="form.cpf"
                label="CPF/CNPJ"
                dense
                outlined
                v-mask="maskCpfCnpj"
                :disabled="!form.tipo_pessoa"
              />
            </v-col>

            <v-col cols="4" class="pl-2">
              <v-text-field
                v-model="form.rg"
                label="RG"
                dense
                outlined
                v-mask="maskRg"
              />
            </v-col>
          </v-row>

          <!-- ENDEREÇO -->
          <v-divider class="my-4"></v-divider>
          <v-row no-gutters>
            <v-col cols="12">
              <h4 class="subtitle-1 font-weight-medium mb-2">Endereço</h4>
            </v-col>

            <v-col cols="4">
              <v-text-field v-model="form.cep" v-mask="maskCEP" label="CEP" dense outlined />
            </v-col>

            <v-col cols="8" class="pl-2">
              <v-text-field v-model="form.endereco" label="Endereço" dense outlined />
            </v-col>

            <v-col cols="4">
              <v-text-field v-model="form.numero" label="Número" dense outlined />
            </v-col>

            <v-col cols="8" class="pl-2">
              <v-text-field v-model="form.bairro" label="Bairro" dense outlined />
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                label="Estado*"
                dense
                outlined
                item-text="descricao"
                item-value="id_uf"
                :items="this.uf"
                @change="loadCidaesUf($event)"
              />
            </v-col>

            <v-col cols="8" class="pl-2">
              <v-autocomplete
                v-model="form.id_cidade"
                label="Cidade*"
                dense
                outlined
                item-value="id_cidade"
                item-text="descricao"
                :loading="loadingCidade"
                :rules="[v => !!v || 'Obrigatório']"
                :items="listCidades"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="form.complemento" label="Complemento" dense outlined />
            </v-col>
          </v-row>

          <!-- EMPRESA E CARGOS -->
          <v-divider class="my-4"></v-divider>
          <v-row no-gutters>
            <v-col cols="12">
              <h4 class="subtitle-1 font-weight-medium mb-2">Empresa e Unidade</h4>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="form.id_empresa"
                label="Empresa*"
                dense
                outlined
                item-text="nome"
                item-value="id_join"
                @change="loadEndpointsByCompany($event)"
                :items="this.companies"
                :loading="loadingComponent"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>

            <v-col cols="6" class="pl-2">
              <v-autocomplete
                v-model="form.id_unidade"
                label="Unidade*"
                dense
                outlined
                item-text="descricao"
                item-value="id_unidade"
                :loading="loadingFieldsCompany || loadingComponent"
                :items="this.unidades"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="form.id_estabel"
                label="Estabelecimento*"
                dense
                outlined
                item-text="nome_estabel"
                item-value="id_estabel"
                :loading="loadingFieldsCompany || loadingComponent"
                :items="this.estabelecimentos"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>

            <v-col cols="6" class="pl-2">
              <v-autocomplete
                v-model="form.id_ccusto"
                label="Centro de Custo*"
                dense
                outlined
                item-text="descricao"
                item-value="id_ccusto"
                :loading="loadingFieldsCompany || loadingComponent"
                :items="this.centro_custos"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="form.id_cargo"
                label="Cargo*"
                dense
                outlined
                item-text="descricao"
                item-value="id_cargo"
                :loading="loadingFieldsCompany || loadingComponent"
                :items="this.cargos"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>

            <v-col cols="6" class="pl-2">
              <v-autocomplete
                v-model="form.id_turno"
                label="Turno*"
                dense
                outlined
                item-text="descricao"
                item-value="id_turno"
                :loading="loadingFieldsCompany || loadingComponent"
                :items="this.turnos"
                :rules="[v => !!v || 'Obrigatório']"
              />
            </v-col>
          </v-row>

          <!-- DADOS BANCÁRIOS -->
          <v-divider class="my-4"></v-divider>
          <v-row no-gutters>
            <v-col cols="12">
              <h4 class="subtitle-1 font-weight-medium mb-2">Dados Bancários</h4>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="form.id_banco"
                label="Banco"
                dense
                outlined
                item-text="descricao"
                item-value="id_banco"
                :items="this.bancos"
              />
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-text-field v-model="form.cod_agencia" label="Agência" dense outlined />
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-text-field v-model="form.cod_ccorrente" label="Conta Corrente" dense outlined />
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="form.tipo_cobranca"
                label="Tipo Cobrança"
                dense
                outlined
                :items="[
                  { text: 'Padrão', value: 1 },
                  { text: 'Nota de débito', value: 2 },
                  { text: 'Boleto Bancário', value: 3 },
                  { text: 'Folha de Pagamento', value: 4 },
                  { text: 'Débito em Conta', value: 5 },
                  { text: 'Não cobrar', value: 6 },
                ]"
              />
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-text-field v-model="form.conta_contabil" label="Conta Contábil" dense outlined />
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-text-field
                v-model="form.dia_vencimento"
                label="Dia Vencimento"
                dense
                outlined
                type="number"
                min="1"
                max="31"
              />
            </v-col>
          </v-row>

          <!-- CONFIGURAÇÕES E COMUNICAÇÃO -->
          <v-divider class="my-4"></v-divider>
          <v-row no-gutters>
            <v-col cols="12">
              <h4 class="subtitle-1 font-weight-medium mb-2">Configurações e Comunicação</h4>
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-checkbox
                v-model="form.dia_util"
                label="Dia útil?"
                hide-details
                dense
              />
            </v-col>

            <v-col cols="3" class="pl-2">
              <v-checkbox
                v-model="form.enviar_comunicados"
                label="Enviar Comunicados"
                hide-details
                dense
                :value="true"
              />
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
        </v-form>
      </v-card-text>

      <!-- Ações -->
      <v-card-actions class="pb-5">
        <v-spacer />
        <v-btn color="gray darken-1" :disabled="meta.sending" @click="close()">Fechar</v-btn>
        <v-btn color="primary" :disabled="isLoading || meta.sending" :loading="meta.sending" @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    value: Boolean,
    newUser: String,
    listUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loadingComponent: true,
      loadingFieldsCompany: false,
      loadingCidade: false,
      form: {
        nome_completo: "",
        nome_abreviado: "",
        bairro: "",
        endereco: "",
        numero: "",
        complemento: "",
        cep: "",
        cpf: "",
        rg: "",
        id_empresa: undefined,
        id_unidade: undefined,
        id_estabel: undefined,
        id_ccusto: undefined,
        id_cidade: undefined,
        id_cargo: undefined,
        tipo_cobranca: undefined,
        id_banco: undefined,
        cod_agencia: "",
        cod_ccorrente: "",
        email: "",
        id_externo: "",
        cod_acesso: "",
        conta_contabil: "",
        id_turno: undefined,
        enviar_comunicados: true,
        codigo_chamada: undefined,
        tipo_pessoa: undefined,
        dia_vencimento: undefined,
        dia_util: undefined,
        group: undefined,
      },
      meta: { loading: true, sending: false },
      listCidades: [],
      maskCpfCnpj: '###.###.###-##',
      maskRg: '#.###.###',
      maskCEP: '#####-###',
    };
  },

  async mounted() {
    try {
      this.form.nome_completo = this.newUser;
      await Promise.all([
        this.loadCompanies(),
        this.loadUf(),
        this.loadBancos(),
      ])
    } catch (error) {
      await this.$swal("Oops...", error.message, "error");
    }

    this.loadingComponent = false;
    this.meta.loading = false;
  },

  methods: {
    ...mapActions("company", ["loadCompanies","loadUf", "loadUnidades", "loadEstabelecimentos", "loadCentroCustos", "loadCargos", "loadTurnos", "loadBancos", "loadCidades"]),
    ...mapActions("persons", ["savePersonJoin"]),

    async loadEndpointsByCompany(event) {
      this.loadingFieldsCompany = true;
      this.form.id_unidade = undefined;
      this.form.id_estabel = undefined;
      this.form.id_ccusto = undefined;
      this.form.id_cargo = undefined;
      this.form.id_turno = undefined;
      try {
        const params = { id_empresa: event }
        await Promise.all([
          this.loadUnidades(params),
          this.loadEstabelecimentos(params),
          this.loadCentroCustos(params),
          this.loadCargos(params),
          this.loadTurnos(params),
        ]);
      } catch (error) {
        await this.$swal("Oops...", error.message, "error");
      }
      this.loadingFieldsCompany = false;
    },

    async loadCidaesUf(event) {
      this.form.id_cidade = undefined;
      this.loadingCidade = true;
      this.listCidades = [];
      await this.loadCidades({ id_uf: event }).catch((error) => {
        this.$swal("Oops...", error.message, "error");
      });
      this.listCidades = this.cidades;
      this.loadingCidade = false;
    },

    updateMask() {
      this.form.cpf = ''
      if (this.form.tipo_pessoa === 1) {
        this.maskCpfCnpj = '###.###.###-##' // CPF
      } else if (this.form.tipo_pessoa === 2) {
        this.maskCpfCnpj = '##.###.###/####-##' // CNPJ
      } else {
        this.maskCpfCnpj = ''
      }
    },

    close() {
      if (!this.meta.sending) this.$emit("close");
    },

    newUserData() {
      this.$emit("newUserData", this.new_person);
    },

    async save() {
      if (this.$refs.validForm.validate()) {
        this.meta.sending = true;
        try {
          await this.savePersonJoin(this.form);
          this.listUsers.push(this.new_person);
          this.newUserData();
          this.meta.sending = false;
          this.close();
        } catch (error) {
          await this.$swal("Oops...", error.message, "error");
          this.meta.sending = false;
        }
      }
    },
  },

  computed: {
    ...mapState(
      "company",
        [
          "companies",
          "uf",
          "unidades",
          "estabelecimentos",
          "centro_custos",
          "cargos",
          "turnos",
          "bancos",
          "cidades",
        ]
    ),
    ...mapState("user", ["user_join"]),
    ...mapState("persons", ["new_person"]),
    isLoading() {
      return this.meta.loading || this.meta.sending;
    },
    emailOrMatriculaRule() {
      return v =>
        this.form.email || this.form.id_externo
          ? true
          : 'Preencha o E-mail ou a Matrícula';
    },
  },
};
</script>

<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
h4 {
  color: #2c3e50;
}
</style>